module.exports = __webpack_public_path__ + "static/media/logo-menu.57057b44.svg";